import { Component, Input, OnInit } from '@angular/core';
import { NavigationHelper } from '@core/services/core/navigation-helper.service';
import { BusinessesLoginHelperService } from '@core/services/helpers/businesses-login-helper.service';
import { BusinessesLoginService } from '@core/services/http-services/businesses-login.service';
import { ModalController } from '@ionic/angular';
import { BusinessLoginUserData } from '@models/business';
import { spinner } from '@utils/rxjs';
import { obfuscateEmail } from '@utils/utils';

@Component({
  selector: 'app-validate-email',
  templateUrl: './validate-email.component.html',
  styleUrls: ['./validate-email.component.scss']
})
export class ValidateEmailComponent implements OnInit {
  @Input() userData: BusinessLoginUserData;
  obfuscatedEmail: string;
  constructor(
    private businessesLoginService: BusinessesLoginService,
    private businessesLoginHelperService: BusinessesLoginHelperService,
    private modalCtrl: ModalController,
    private nav: NavigationHelper
  ) {}

  ngOnInit() {
    this.obfuscatedEmail = obfuscateEmail(this.userData?.email);
  }

  onContinue() {
    this.dismissModal();
  }

  forwardEmail() {
    this.businessesLoginService
      .sendVerification(this.userData, false)
      .pipe(spinner('forward-email'))
      .subscribe(
        () => {
          this.nav.toNew(['businesses', 'email', 'forward', 'result'], {
            state: {
              isSuccess: true,
              comesFromUpdatingEmail: false,
              userData: this.userData
            }
          });
        },
        error => {
          this.businessesLoginHelperService.onForwardEmailError(
            error.errorCode,
            this.userData,
            false
          );
        }
      );
    this.dismissModal();
  }

  changeEmail() {
    this.nav.toNew(['businesses', 'email', 'update'], {
      state: {
        isOutOfRegisterProcess: true,
        userData: this.userData
      }
    });
    this.dismissModal();
  }

  private dismissModal() {
    this.modalCtrl.dismiss();
  }
}
